import React from 'react'
import {
    Typography
} from '@material-ui/core'
import { smartNotesToList } from '../../../utils/productEdit'

export default function SmartNotes({ smartNotes = '', className, typographyColor = 'inherit', typographySize = 16 }) {
    return (
        <div className={className}>
            {
                smartNotesToList(smartNotes).map((note, index) =>
                    <Typography key={index} color={typographyColor} style={{ fontSize: typographySize }} >{note}</Typography>
                )
            }
        </div>
    )
}
